import { useQuery } from "@tanstack/react-query";
import { fetchWeekAppointmentsForStaff } from "@/lib/services/appointmentService";
import type { Appointment } from "@/lib/types";
import { useAuth } from "@/features/auth/AuthContext";

/**
 * React Query hook for fetching week appointments for a staff member.
 * @param staffId - The staff member's ID
 * @param weekDates - Array of week date strings (YYYY-MM-DD)
 */
export function useWeekAppointmentsForStaff(staffId: number | undefined, weekDates: string[] | undefined) {
  return useQuery<Record<string, Appointment[]>>({
    queryKey: ["weekAppointmentsForStaff", staffId, weekDates],
    queryFn: () => {
      if (staffId === undefined || !weekDates || weekDates.length === 0) {
        return Promise.resolve({});
      }
      return fetchWeekAppointmentsForStaff(staffId, weekDates);
    },
    enabled: staffId !== undefined && !!weekDates && weekDates.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 60_000, // defensive liveness for passive viewers (doc 07 Phase B)
  });
}
